import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";
import Home from "@/pages/Home";
import Hakkimizda from "@/pages/Hakkimizda";
import Hizmetler from "@/pages/Hizmetler";
import Referanslar from "@/pages/Referanslar";
import Paketler from "@/pages/Paketler";
import Iletisim from "@/pages/Iletisim";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  useLenis();
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hakkimizda" element={<Hakkimizda />} />
            <Route path="/hizmetler" element={<Hizmetler />} />
            <Route path="/referanslar" element={<Referanslar />} />
            <Route path="/paketler" element={<Paketler />} />
            <Route path="/iletisim" element={<Iletisim />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <FloatingActions />
      </BrowserRouter>
    </div>
  );
}

export default App;
